import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useCircleV4 } from "@/react/hooks/useCircleV4";
import type { CircleV4FeatureFlags } from "@/react/types/CommunitySettings";

export const useIsCircleV4FeatureEnabled = (
  featureFlag: keyof CircleV4FeatureFlags,
  { requireAdminArea = true }: { requireAdminArea?: boolean } = {},
) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { isCircleV4 } = useCircleV4();
  const isAdminArea = useIsAdminArea();
  const isFeatureEnabled = Boolean(currentCommunitySettings?.[featureFlag]);

  return (
    isCircleV4 || ((requireAdminArea ? isAdminArea : true) && isFeatureEnabled)
  );
};
